module.exports = __webpack_public_path__ + "img/triangle--light--down.9ce853ac.svg";